import React from 'react';
import {Grid, Typography} from '@mui/material';
import RequestLocationForm from './RequestLocationForm';
import {PlacePrediction} from '../../placesAutocomplete/interfaces';
import LocationOffOutlinedIcon from '@mui/icons-material/LocationOffOutlined';
import {alpha, styled} from "@mui/material/styles";

const LocationSearchNoContentContainer = styled(Grid)(() => ({
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '1em'
}));

const LocationSearchHeadingContainer = styled(Grid) (() => ({
    width: '80%',
    flexDirection: 'column',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    margin: '1em'
}));

const NoLocationIcon = styled('div')(({theme}) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: 88,
    height: 88,
    color: theme.palette.primary.main,
    backgroundColor: alpha(theme.palette.primary.light, 0.3),
    borderRadius: '50%'
}))

interface LocationSearchNoContentProps {
    /** Resolved city for the searched area, forwarded to the request form. */
    city?: string;
    /** Resolved state for the searched area, forwarded to the request form. */
    state?: string;
    /** When true (coordinate/drag mode) the city/state is user-editable; otherwise it's locked to the searched city. */
    editable?: boolean;
    /** Search/navigate to the city picked in the editable city field. */
    onCitySearch?: (pacItem: PlacePrediction) => void;
}

const LocationSearchNoContent = (props: LocationSearchNoContentProps) => {
    return (
        <LocationSearchNoContentContainer>
            <LocationSearchHeadingContainer>
                <NoLocationIcon>
                    <LocationOffOutlinedIcon sx={{ fontSize: 44 }}/>
                </NoLocationIcon>
                <Typography variant='h4'>No Locations Here Just Yet</Typography>
                <Typography variant='subtitle2'>Tell us what you're looking for and we'll work to add locations in this area.</Typography>
            </LocationSearchHeadingContainer>
            <RequestLocationForm city={props.city} state={props.state} editable={props.editable} onCitySearch={props.onCitySearch}/>
        </LocationSearchNoContentContainer>
    );
};

export default LocationSearchNoContent;
